
import Form from './Form'

class FormDataForm extends Form {

  /**
   * Fetch all relevant data for the form.
   * 
   * @return {object}
   */
  data() {
    let data = new FormData();

    for (let property in this.originalData) {
      data.append(property, this[property]);
    }

    return data;
  }
}

export default FormDataForm;